import { useState } from "react";
import { MdAccountBalance } from "react-icons/md";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import {  useSelector } from "react-redux";
import { createProduct } from "../../../redux/features/product/productSlice";
import {
  getAllProducts,
  getProductDetails,
  updateProduct,
} from "../../../redux/features/product/productSlice";

function Edit() {
  const navigate = useNavigate();
    const { product, loading } = useSelector((state) => state.products.product);

  const dispatch = useDispatch();

  const [name, setName] = useState(product.name||"");
  const [brand, setBrand] = useState(product.brand||"");
  const [category, setCategory] = useState(product.category || "");
  const [description, setDescription] = useState(product.description || "");
  const [price, setPrice] = useState(product.price||"");
  const [discount, setDiscount] = useState(product.discount ||"");
  const [stock, setStock] = useState(product.stock ||0);
  const [images, setImages] = useState([]);
  const [imagesPreview, setImagesPreview] = useState([]);

  const categories = ["Laptop", "Mobile", "SmartWatch", "Monitor"];

  // Sepcification Hanlder
  const [specification, setSpecification] = useState([]);
  const [nam, setNam] = useState("");
  const [val, setVal] = useState("");
  const spec = {
    name: nam,
    value: val,
  };

  ///////////////////key feature
  const [keyFeatures, setKeyFeatures] = useState(product.keyFeatures||[""]);

  const keyChange = (index, event) => {
    const values = [...keyFeatures];
    values[index] = event.target.value;
    setKeyFeatures(values);
  };

  const keyAddInput = () => {
    setKeyFeatures([...keyFeatures, ""]);
  };

  const onSubmitHandler = (e) => {
    e.preventDefault();
    setSpecification([...specification, spec]);
    setNam("");
    setVal("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Create an object with the form data
    const productData = {
      name,
      brand,
      category,
      description,
      price,
      discount,
      stock,
      images,
      spec:specification,
    keyFeatures
    };
    // console.log(productData);
    // Dispatch the createProduct action with the productData
    // dispatch(createProduct(productData));
    // console.log(productData);

    //dispatch(getAllProduct);

    // Reset form fields and state after submission
    // setName("");
    // setBrand("");
    // setCategory("");
    // setDescription("");
    // setPrice("");
    // setDiscount("");
    // setStock(0);
    // setImages([]);
    // setImagesPreview([]);
    // setSpecification([]);

    // navigate("/");
  };

  const createProductImagesChange = (e) => {
    const files = Array.from(e.target.files);

    setImages([]);
    setImagesPreview([]);

    files.forEach((file) => {
      const reader = new FileReader();

      reader.onload = () => {
        if (reader.readyState === 2) {
          setImagesPreview((old) => [...old, reader.result]);
          setImages((old) => [...old, reader.result]);
        }
      };

      reader.readAsDataURL(file);
    });
  };

  return (
    <div className=" px-[10px] md:px-[20px] lg:px-[3%]">
      <Link to="/admin">
        <img className=" h-16" src="/utils/back.png" alt="" />
      </Link>
      <h1 className="m-5 font-semibold text-center">Add Product</h1>

      <form
        className="bg-white pb-10 rounded-lg shadow-md w-[95vw] lg:max-w-[80vw] mx-auto p-6 "
        onSubmit={handleSubmit}
      >
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 ">
          <div className="mb-1 lg:mb-4">
            <label htmlFor="name" className="block text-Light font-medium mb-2">
              Name
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full bg-BlueDark  border-gray-400 border-2 p-2 rounded-lg focus:outline-none focus:border-orange-500"
            />
          </div>
          {/* <div className="mb-1 lg:mb-4">
            <label
              htmlFor="image"
              className="block text-Light font-medium mb-2"
            >
              Image URL
            </label>
            <input
              type="text"
              id="image"
              name="image"
              value={image}
              onChange={(e) => setImage(e.target.value)}
              className="w-full bg-BlueDark border-gray-400 border-2 p-2 rounded-lg focus:outline-none focus:border-orange-500"
            />
          </div> */}
          <div className="mb-1 lg:mb-4">
            <label
              htmlFor="brand"
              className="block text-Light font-medium mb-2"
            >
              Brand
            </label>
            <input
              type="text"
              id="brand"
              name="brand"
              value={brand}
              onChange={(e) => setBrand(e.target.value)}
              className="w-full bg-BlueDark border-gray-400 border-2 p-2 rounded-lg focus:outline-none focus:border-orange-500"
            />
          </div>
          {/* <div className="mb-1 lg:mb-4">
          <label
            htmlFor="category"
            className="block text-Light font-medium mb-2"
          >
            Category
          </label>
          <input
            type="text"
            id="category"
            name="category"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            className="w-full bg-BlueDark border-gray-400 border-2 p-2 rounded-lg focus:outline-none focus:border-orange-500"
          />
        </div> */}

          <div className="mb-1 lg:mb-4">
            {/* <MdAccountBalance /> */}
            <label
              htmlFor="category"
              className="block text-Light font-medium mb-2"
            >
              Category
            </label>
            <select
              className="w-full bg-BlueDark border-gray-400 border-2 p-2 rounded-lg focus:outline-none focus:border-orange-500"
              onChange={(e) => setCategory(e.target.value)}
            >
              <option value="">Choose Category</option>
              {categories.map((cate) => (
                <option key={cate} value={cate}>
                  {cate}
                </option>
              ))}
            </select>
          </div>

          <div className="mb-1 lg:mb-4">
            <label
              htmlFor="description"
              className="block text-Light font-medium mb-2"
            >
              Description
            </label>
            <textarea
              id="description"
              name="description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="w-full bg-BlueDark border-gray-400 border-2 p-2 rounded-lg focus:outline-none focus:border-orange-500"
            />
          </div>
          <div className="mb-1 lg:mb-4">
            <label
              htmlFor="price"
              className="block text-Light font-medium mb-2"
            >
              Price
            </label>
            <input
              type="number"
              id="price"
              name="price"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
              className="w-full bg-BlueDark border-gray-400 border-2 p-2 rounded-lg focus:outline-none focus:border-orange-500"
            />
          </div>
          <div className="mb-1 lg:mb-4">
            <label
              htmlFor="price"
              className="block text-Light font-medium mb-2"
            >
              Stock
            </label>
            <input
              type="number"
              id="stock"
              name="stock"
              value={stock}
              onChange={(e) => setStock(e.target.value)}
              className="w-full bg-BlueDark border-gray-400 border-2 p-2 rounded-lg focus:outline-none focus:border-orange-500"
            />
          </div>
          <div className="mb-1 lg:mb-4">
            <label
              htmlFor="discount"
              className="block text-Light font-medium mb-2"
            >
              Discount
            </label>
            <input
              type="number"
              id="discount"
              name="discount"
              value={discount}
              onChange={(e) => setDiscount(e.target.value)}
              className="w-full bg-BlueDark border-gray-400 border-2 p-2 rounded-lg focus:outline-none focus:border-orange-500"
            />
          </div>

          {/* Images */}
          <div className="mb-1 lg:mb-4" id="createProductFormFile">
            <label
              htmlFor="images"
              className="block text-Light font-medium mb-2"
            >
              Choose Images
            </label>
            <input
              id="images"
              className="w-full bg-BlueDark border-gray-400 border-2 p-2 rounded-lg focus:outline-none focus:border-orange-500"
              type="file"
              name="avatar"
              accept="image/*"
              onChange={createProductImagesChange}
              multiple
            />
          </div>

          <div className="block mb-2 border border-gray-300 p-5 rounded-lg">
            <label
              htmlFor="keyFeatures"
              className="block text-Light font-medium mb-2"
            >
              Key Features
            </label>
            {keyFeatures.map((feature, index) => (
              <input
                key={index}
                type="text"
                name={`keyFeatures-${index}`}
                placeholder={`Key Feature ${index + 1}`}
                value={feature}
                onChange={(event) => keyChange(index, event)}
                className="w-full bg-BlueDark border-gray-400 border-2 p-2 rounded-lg focus:outline-none focus:border-orange-500 mb-6"
              />
            ))}
            <span
              className="bg-orange-500 hover:bg-orange-600 text-white font-bold py-2 px-4 rounded"
              onClick={keyAddInput}
            >
              ADD MORE FEATURES
            </span>
          </div>

          {/* Specification Field */}

          <div>
            {/* <hr /> */}
            <h1 className=" font-semibold">Add Specification</h1>
            <div className=" border p-2 rounded ">
              <div className="mb-1 lg:mb-4 grid grid-cols-2">
                <div>
                  <label
                    htmlFor="name"
                    className="block text-Light font-medium mb-2"
                  >
                    Name
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="reviews"
                    value={nam}
                    onChange={(e) => setNam(e.target.value)}
                    className="w-full bg-BlueDark border-gray-400 border-b-2 border-t-2 border-l-2 p-2 rounded-l-lg focus:outline-none focus:border-orange-500"
                  />
                </div>
                <div>
                  <label
                    htmlFor="value"
                    className="block text-Light font-medium mb-2"
                  >
                    Value
                  </label>
                  <input
                    type="text"
                    id="value"
                    name="reviews"
                    value={val}
                    onChange={(e) => setVal(e.target.value)}
                    className="w-full bg-BlueDark border-gray-400 border-2 p-2 rounded-r-lg focus:outline-none focus:border-orange-500"
                  />
                </div>
              </div>

              <button
                onClick={onSubmitHandler}
                type="submit"
                className=" bg-orange-500 text-white px-4 py-1 my-2 lg:px-8 lg:py-2 rounded text-lg font-semibold"
              >
                ADD
              </button>
            </div>
            {/* <hr /> */}
          </div>
        </div>
        <div className="flex flex-col items-center justify-center pt-10">
          <div
            className="border flex flex-row flex-wrap p-5 my-2"
            id="createProductFormImage"
          >
            {imagesPreview.map((image, index) => (
              <img
                className="h-16 m-1"
                key={index}
                src={image}
                alt="Product Preview"
              />
            ))}
          </div>

          <button
            type="submit"
            className="px-10 py-2 rounded-lg text-white w-fit text-center bg-orange-500 hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2"
          >
            Add Product
          </button>
        </div>
      </form>
    </div>
  );
}

export default Edit;
